export class DisclaimerAccessValidator {
    constructor() {
        this.switzerland = '215';
        this.luxembourg = '130';
        this.spain = '208';
        this.france = '77';
        this.unitedKingdom = '234';

        this.countriesWithAccess = [ this.switzerland, this.luxembourg, this.spain, this.france, this.unitedKingdom ];
    }

    isLuxembourg(selectedCountry) {
        return selectedCountry === this.luxembourg;
    }

    hasAccess(selectedCountry) {
        return true;
    }
}